import React from 'react';
import StatusButton from './StatusButton';

function OrderStatus() {
    return (
        <div className="pos_status">
            <div className="status_container">
                <div className="status_items">
                    <StatusButton btName="Available" className="bt3" />
                    <StatusButton btName="Ongoing" className="bt2" />
                    <StatusButton btName="Complete" className="bt1" />
                </div>
            </div>
        </div>
    );
}

export default OrderStatus;
